import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "5bb83b93-27db-424b-bda5-d7c5109facd5",
    content: "Radiosity method only considers diffuse reflections",
    options: {},
  },
  {
    id: "d0b35903-7e84-4603-bf36-155559fe5fd9",
    content: "The Finite-Element Method is limited to simple geometry",
    options: {},
  },
  {
    id: "4e89b8de-bf63-48d4-b7d7-e25276fedeb9",
    content: "Radiosity method takes diffraction into account",
    options: {},
  },
  {
    id: "f1eb1d8e-ea3c-4bfe-9c25-eac7e6c971eb",
    content: "Boundary Element Method is associated to a volumic mesh",
    options: {},
  },
  {
    id: "bf66589f-3273-4b7b-864f-6870746984cf",
    content: "The mesh of Finite-Differences can be unstructured ",
    options: {},
  },
  {
    id: "60e8d2f7-0190-46ae-b7c9-1c86f4e67c44",
    content: "Image source method is limited to perfect reflectors",
    options: {},
  },
  {
    id: "92d5377b-8b1a-46b6-be82-142d58d632a6",
    content: "Radiosity method is a good choice to model early reflections",
    options: {},
  },
  {
    id: "5fa1a3b1-2f97-4642-809c-741e3c252f6b",
    content: "Ray tracing cannot take diffuse reflection into account ",
    options: {},
  },
];

export const task: Task = {
  id: "22dc8737-5b1b-433c-a2d0-f53861947174",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 1,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["5bb83b93-27db-424b-bda5-d7c5109facd5"],
};
